/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-browser-update-banner',
  template: `
    <div class="warningBanner blockedBanner" *ngIf="!forceOff && unsupported">
      <p style="font-size: 25px">Your Browser Isn't Supported</p>
      <p>We use some more advanced commands that your current browser doesn't support.</p>
      <p>Update your browser to a later version to ensure all functionality is available to you.</p>
      <p><a (click)="forceOff = true"><span class="fa fa-times-circle"></span> Turn this warning off</a></p>
    </div>
  `
})
export class BrowserUpdateBannerComponent implements OnInit {
  unsupported = false;
  forceOff = false;

  ngOnInit(): void {
    const hasOwn = (Object as {hasOwn?: (obj: object, key: PropertyKey) => boolean}).hasOwn;
    if (hasOwn) {
      this.unsupported = !hasOwn(this, 'unsupported');
    } else {
      this.unsupported = true;
    }
  }
}
